import { ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables } from 'generated/apiComponents';

export type ActivityAggregationLevel =
  ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables['body']['aggregationLevel'];

export const ACTIVITY_AGGREGATION_LEVELS = [
  '1',
  '2',
  '3',
  '4',
] as const satisfies ActivityAggregationLevel[];

export const ACTIVITY_AGGREGATION_LEVELS_MAP = {
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
} satisfies { [K in ActivityAggregationLevel]: K };

export type ActivityGroupByType =
  ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables['body']['groupByType'];

export const ACTIVITY_GROUP_BY_TYPES = [
  'report',
  'day',
  'week',
  'month',
  'ring',
  'activity',
] as const satisfies ActivityGroupByType[];

export const ACTIVITY_GROUP_BY_TYPES_MAP = {
  report: 'report',
  day: 'day',
  week: 'week',
  month: 'month',
  ring: 'ring',
  activity: 'activity',
} as const satisfies { [K in ActivityGroupByType]: K };

export type ActivityCriticalType =
  ActivityAnalyzeV1ControllerReportActivityAnalyzeVariables['body']['criticalType'];

export const ACTIVITY_CRITICAL_TYPES = [
  'all',
  'critical',
  'nonCritical',
] as const satisfies ActivityCriticalType[];

export const ACTIVITY_CRITICAL_TYPES_MAP = {
  all: 'all',
  critical: 'critical',
  nonCritical: 'nonCritical',
} as const satisfies { [K in ActivityCriticalType]: K };

export type ReportActivityAnalyzeGraphPoint = {
  // Cannot uncomment this because of type safety but theses fields can exist
  // rowDisplay?: string;
  // rowDisplayShiftName?: string

  // The `string` is required to match the record signature
  [serieId: string]: number | string;
};

export const ACTIVITY_DISPLAY_TYPES = ['bar', 'pie', 'table'] as const;
export type ActivityDisplayTypes = (typeof ACTIVITY_DISPLAY_TYPES)[number];

export const ACTIVITY_DISPLAY_TYPES_MAP = {
  bar: 'bar',
  pie: 'pie',
  table: 'table',
} as const satisfies { [K in ActivityDisplayTypes]: K };

export type ReportActivitySerie = {
  id: string;
  nameLevelMax: string;
  type: string;
};

export type ReportActivitySeriesMap = Record<
  string,
  Omit<ReportActivitySerie, 'id'>
>;
